import { render } from "./AppMain.vue?vue&type=template&id=5077b6d7&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=5077b6d7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5077b6d7"]])

export default __exports__